(function () {
    'use strict';

    let mediaDivReady = false;

    function init() {
        const firstMedia = document.querySelector('.js-media');
        if (firstMedia) {
            if (firstMedia.complete) {
                nextMedia();
            } else {
                firstMedia.addEventListener('load', nextMedia, { once: true });
                firstMedia.addEventListener('canplaythrough', nextMedia, { once: true });
            }
        }
    }

    function handleBounceEvent() {
        document.addEventListener('ballBounce', nextMedia);
    }

    function displayMediaDiv() {
        const mediaDiv = document.querySelector('.js-mediaContainer');
        mediaDiv.classList.add('frontPageMedia--ready');
        mediaDivReady = true;
    }

    function nextMedia() {

        const mediaElements = document.querySelectorAll('.js-media');

        if (mediaElements[0] && mediaElements[0].tagName.toLowerCase() === 'img') {
            if (mediaElements[0].complete) {
                mediaElements[0].style.opacity = 1;
                const parent = mediaElements[0].parentNode;

                parent.appendChild(mediaElements[0]);

                if (!mediaDivReady) {
                    displayMediaDiv();
                }
            }
        } else if (mediaElements[0] && mediaElements[0].tagName.toLowerCase() === 'video') {
            if (mediaElements[0].readyState === 4) {
                mediaElements[0].style.opacity = 1;
                const parent = mediaElements[0].parentNode;

                pauseAllVideosExcept(mediaElements[0]);
                mediaElements[0].play();

                parent.appendChild(mediaElements[0]);

                if (!mediaDivReady) {
                    displayMediaDiv();
                }
            }
        }

    }

    function pauseAllVideosExcept(thisVideo) {
        const videoElements = document.querySelectorAll('.js-media-video');

        videoElements.forEach(function(vid) {
            if (thisVideo !== vid) {
                vid.pause();
                vid.currentTime = 0;
            }
        });
    }

    init();
    handleBounceEvent();
})();